import React from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { departmentChipTextColor, departmentColorCode } from '../utilities/departmentColors.js';

const PreferencesBar = ({ selectedPreferences, updatePreferences, preferenceOptions }) => {
    const selectedItemTemplate = (selected) => {
        if (selected == null || selected === '') {
            return null;
        }

        const name = typeof selected === 'string' ? selected : (selected.name || selected.value);
        const option = (preferenceOptions || []).find((item) => item.value === name || item.name === name);
        const color = '#' + departmentColorCode(name, option?.color);
        const textColor = departmentChipTextColor(color);

        const removeDepartment = (event) => {
            event.preventDefault();
            event.stopPropagation();
            const remaining = (selectedPreferences || []).filter((item) => {
                const itemName = typeof item === 'string' ? item : (item?.name || item?.value);
                return itemName !== name;
            });
            updatePreferences(remaining);
        };

        return (
            <div className="p-multiselect-token dept-chip" style={{ background: color, color: textColor }}>
                <span className="p-multiselect-token-label">{option?.name || name}</span>
                <span className="p-multiselect-token-icon pi pi-times-circle" onClick={removeDepartment} />
            </div>
        );
    };

    return (
        <MultiSelect
            value={selectedPreferences}
            className="preference-dropdown"
            panelClassName="preference-dropdown-panel"
            onChange={(e) => updatePreferences(e.value)}
            options={preferenceOptions}
            optionLabel="name"
            display="chip"
            placeholder="Select Department..."
            selectedItemTemplate={selectedItemTemplate}
        />
    );
};

export default PreferencesBar;
